/**
 * Export filename builder per §0.2 of M3X.REPORTS:
 *   `{title}_{period}_{YYYYMMDD-HHmm}.{ext}`
 *
 * - Slugifies the title (strips non [A-Za-z0-9_-]+, collapses underscores).
 * - Period is optional; omit by passing `null`.
 * - Timestamp is always UTC to avoid TZ ambiguity in filenames.
 */

export function buildExportFilename(opts: {
  title: string;
  period?: string | null;
  ext: "xlsx" | "csv" | "pdf";
  now?: Date;
}): string {
  const slug = slugify(opts.title);
  const period = opts.period ? slugify(opts.period) : "";
  const ts = formatTimestamp(opts.now ?? new Date());
  const parts = [slug, period, ts].filter((p) => p.length > 0);
  return `${parts.join("_")}.${opts.ext}`;
}

function slugify(s: string): string {
  return s
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9_-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}

function formatTimestamp(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  const h = String(d.getUTCHours()).padStart(2, "0");
  const mn = String(d.getUTCMinutes()).padStart(2, "0");
  return `${y}${m}${day}-${h}${mn}`;
}
